import axios from 'axios';
import type { SetOrgSettingsDTO } from '@bb/domain/dist/types';

const saveOrgSettings = async (newSettings: SetOrgSettingsDTO) => {
  await axios.post(`/org/settings`, newSettings);
};

export default saveOrgSettings;
